/** @jsx jsx */
import { jsx } from '@emotion/react';

import { type TransformedTokenGrouped } from '../types';

type TokenDescriptionProps = {
  isLoading?: boolean;
  transformedToken?: TransformedTokenGrouped;
};

const TokenDescription = (props: TokenDescriptionProps) => {
  const { isLoading, transformedToken } = props;
  if (isLoading || !transformedToken) {
    return null;
  }

  return (
    <p css={{ margin: 0, overflowWrap: 'anywhere', textAlign: 'start' }}>
      {transformedToken.attributes.description}
    </p>
  );
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default TokenDescription;
